export default "__VITE_ASSET__C0487wnh__"